// extracted by mini-css-extract-plugin
export default {"root":"Step2Form_root__FjDhg","cancelBtn":"Step2Form_cancelBtn__wT4ot"};